import { useEffect } from "react";
import { getToken } from "firebase/messaging";
import { useDispatch, useSelector } from "react-redux";
import { FIREBASE_VAPID_KEY } from "src/app.config";
import { messaging } from "src/config/firebase";

import { NOTIFICATION } from "@constants/user";
import API_SERVICES from "@services/index";
import localSlice from "@slices/local.slice";
import { RootState } from "@store/index";

export const useFirebaseNotification = () => {
  const dispatch = useDispatch();
  const { fcmToken, isAuthenticated } = useSelector(
    (state: RootState) => state.local
  );

  useEffect(() => {
    if (isAuthenticated) {
      registerNotificationToken();
    }
  }, [isAuthenticated, fcmToken]);

  const registerNotificationToken = async () => {
    const token = await requestNotificationPermission();

    if (token) {
      const API_TYPE = fcmToken
        ? API_SERVICES.NOTIFICATION.ENABLE
        : API_SERVICES.NOTIFICATION.SUBSCRIBE;

      const response = await API_TYPE(token);

      if (response?.ok) {
        dispatch(localSlice.actions.setFcmToken(token));
      } else {
        dispatch(localSlice.actions.setFcmToken(""));
      }
    } else {
      dispatch(localSlice.actions.setFcmToken(""));
    }
  };

  const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();

    if (permission === NOTIFICATION.PERMISSION_GRANTED) {
      if (!FIREBASE_VAPID_KEY) {
        return;
      }

      const token = await getToken(messaging, {
        vapidKey: FIREBASE_VAPID_KEY,
      });

      if (token) {
        return token;
      }
    }
  };
};
